import type { StorageAddonId } from './storagePlans';
export const MANUAL_STORAGE_CONSENT_VERSION = 'manual-storage-2026-10-25';
export interface ManualStorageOrder {
  id: string; kind: 'addon' | 'renewal'; offerId: StorageAddonId | null; paymentMethod: 'card' | 'promptpay';
  amountTotal: number; storageAmount: number; periodStart: number; periodEnd: number; expiresAt: number; serverNow: number;
  status: 'quoted' | 'processing' | 'pending' | 'paid' | 'refunded' | 'expired' | 'superseded'; checkoutUrl?: string;
  paymentState?: 'processing' | 'requires_review';
}
export type ManualStorageState = { enabled: false } | {
  enabled: true; eligible: boolean; canAddon: boolean; proExpiresAt: number | null;
  currentPeriod: { start: number; end: number } | null;
  currentStorage: { offerId: StorageAddonId; end: number } | null;
  scheduledStorage: Array<{ offerId: StorageAddonId; start: number; end: number }>;
  order: ManualStorageOrder | null;
};
export function safeManualCheckoutUrl(value: unknown) {
  if (typeof value !== 'string') return undefined;
  try { const url = new URL(value); if (url.protocol === 'https:' && url.hostname === 'checkout.stripe.com' && !url.username && !url.password) return url.href; } catch { /* Invalid provider link. */ }
}
